export enum PriceModifierType {
  WoodType = "priceModifiersWoodType",
  HumidityLevel = "priceModifiersHumidityLevel",
  CuttingLength = "priceModifiersCuttingLength",
}
